import { dsClass } from '../../common/constants/dsClasses.js';
import { useSearchParams } from '../../common/hooks/useSearchParams.js';
import { t } from '../../common/i18n/index.js';
import { ConsolidatedListView } from '../../components/ConsolidatedListView/ConsolidatedListView.js';
import { useAuth } from '../../public/site/AuthProvider.js';
import { Grid } from '../Grid/Grid.js';
import { InvoiceTable } from '../Invoices/Invoices.js';
import { DEFAULT_ITEMS_PER_PAGE, ListPagination, ListSearch } from '../Table/index.js';
import { setDefaultItemsPerPage } from '../Table/tableUtils.js';
import type { InvoicesSearchResponse } from '../../generated/api/models.js';
import type { DefaultListSearchParams } from '../Table/index.js';

import './InvoiceList.scss';

export interface InvoiceListProps {
  invoices?: InvoicesSearchResponse[];
  total: number;
}

export const InvoiceList = ({ invoices, total }: InvoiceListProps) => {
  const { authenticatedUser } = useAuth();
  const searchParams = useSearchParams<DefaultListSearchParams>();
  const { search } = searchParams;

  return (
    <Grid>
      <div className="of-invoice-list">
        <ConsolidatedListView
          authenticatedUser={authenticatedUser}
          listSearch={
            <ListSearch
              className={dsClass.MARGIN_TOP_4}
              onSearch={() => setDefaultItemsPerPage(new URLSearchParams(searchParams), DEFAULT_ITEMS_PER_PAGE)}
            />
          }
          listElement={
            <InvoiceTable authenticatedUser={authenticatedUser} invoices={invoices || []} search={search || ''} />
          }
          listPagination={<ListPagination totalItems={total} />}
          wideLayout={true}
        />
      </div>
      <div className={`${dsClass.TEXT_SMALL} ${dsClass.MARGIN_TOP_4}`}>
        * {t.YM3W('Showing the current information of the billing account.')}
      </div>
    </Grid>
  );
};
